// extracted by mini-css-extract-plugin
export default {"pageLayout":"P-z","mainContent":"Q-z","columnLayout":"R-z","columnLayoutFill":"S-z","columnLayoutLast":"T-z"};